export const dashboardRoutes = {
  label: 'Dashboard',
  labelDisable: true,
  children: [
    {
      name: 'Dashboard',
      active: true,
      icon: 'chart-pie',
      to: '/'
    }
  ]
};
export const donorRoutes = {
  label: '',
  labelDisable: false,
  children: [
    {
      name: 'Donors',
      active: true,
      icon: 'users',
      to: '/donors'
    }
  ]
};
export const sponsorshipsRoutes = {
  label: 'Sponsorships',
  labelDisable: true,
  children: [
    {
      name: 'Sponsorships',
      active: true,
      icon: 'hands-helping',
      children: [
        {
          name: 'All Beneficiaries',
          to: '/beneficiaries',
          exact: true,
          active: true
        },
        {
          name: 'Sponsored List',
          to: '/beneficiaries/sponsored_list',
          exact: true,
          active: true
        },
        {
          name: 'Unsponsored list',
          to: '/beneficiaries/unsponsored_list',
          exact: true,
          active: true
        }
      ]
    }
  ]
};
export const projectRoutes = {
  label: 'Projects',
  labelDisable: true,
  children: [
    {
      name: 'Projects',
      active: true,
      icon: 'project-diagram',
      children: [
        {
          name: 'Kanban',
          to: '/project/kanban',
          exact: true,
          active: true
        },
        {
          name: 'Project List',
          to: '/project/list',
          exact: true,
          active: true
        }
      ]
    }
  ]
};

export const staffRoutes = {
  label: 'Staff',
  labelDisable: true,
  children: [
    {
      name: 'Staff',
      active: false,
      disable: true,
      icon: 'users',
      to: '/staff'
    }
  ]
};
export const reportsRoutes = {
  label: 'Reports',
  labelDisable: true,
  children: [
    {
      name: 'Reports',
      active: false,
      disable: true,
      icon: 'user-edit',
      to: '/reports'
    }
  ]
};

export const kanbanProjectRoutes = {
  label: 'Main Projects',
  children: [
    {
      name: 'Main Dashboard',
      icon: ['fab', 'trello'],
      to: '#',
      active: true
    },
    {
      name: 'All',
      icon: ['fab', 'trello'],
      to: '#',
      active: true
    },
    {
      name: 'Somalia',
      icon: 'graduation-cap',
      active: true,
      children: [
        {
          name: 'City 1',
          to: '#',
          active: true
        },
        {
          name: 'City 2',
          to: '#',
          active: true
        },
        {
          name: 'City 3',
          to: '#',
          active: true
        }
      ]
    },
    {
      name: 'Kenya',
      icon: 'graduation-cap',
      active: true,
      children: [
        {
          name: 'City 1',
          to: '#',
          active: true
        },
        {
          name: 'City 2',
          to: '#',
          active: true
        },
        {
          name: 'City 3',
          to: '#',
          active: true
        }
      ]
    },

    {
      name: 'uk',
      icon: 'share-alt',
      active: true,
      children: [
        {
          name: 'City 1',
          to: '#',
          active: true
        }
      ]
    },
    {
      name: 'Ethiopia',
      icon: 'share-alt',
      active: true,
      children: [
        {
          name: 'City 1',
          to: '#',
          active: true
        },
        {
          name: 'City 2',
          to: '#',
          active: true
        },
        {
          name: 'City 3',
          to: '#',
          active: true
        }
      ]
    },
    {
      name: 'Yemen',
      icon: 'share-alt',
      active: true,
      children: [
        {
          name: 'City 1',
          to: '#',
          active: true
        },
        {
          name: 'City 2',
          to: '#',
          active: true
        },
        {
          name: 'City 3',
          to: '#',
          active: true
        }
      ]
    }
  ]
};

export default [
  dashboardRoutes,
  donorRoutes,
  sponsorshipsRoutes,
  projectRoutes,
  staffRoutes,
  reportsRoutes
];
